import React from 'react';
import Icon from './icon';
import { IconProps } from './types';

const ICON_PATH = 'M7.2636 18.4826C6.91213 18.8297 6.91213 19.3925 7.2636 19.7397C7.61508 20.0868 8.18493 20.0868 8.5364 19.7397L15.7364 12.6285C16.0879 12.2814 16.0879 11.7186 15.7364 11.3715L8.5364 4.26035C8.18493 3.91322 7.61508 3.91322 7.2636 4.26035C6.91213 4.60748 6.91213 5.1703 7.2636 5.51743L13.8271 11.9999L7.2636 18.4826Z';

export const ArrowNextIcon: React.FC<IconProps> = ({ size, color, style, viewBox }) => {
	return <Icon style={style} path={ICON_PATH} size={size} color={color} viewBox={viewBox} />;
};
